import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Fade from '@mui/material/Fade';
import useStyles from './styles';

const defaultColor = '#FC4B58';

function InfoButton({
	message,
	iconColor = defaultColor,
	bgColor = '',
	hoverBgColor = '',
	size = 'medium',
	iconSize = 'medium',
	customIconStyles = {}
}) {
	const classes = useStyles();

	return (
		<Tooltip
			title={message}
			arrow
			TransitionComponent={Fade}
			TransitionProps={{
				timeout: 350
			}}
			slotProps={{
				tooltip: {
					sx: {
						backgroundColor: '#fff',
						color: '#111',
						fontSize: '1.4rem',
						fontWeight: 500,
						padding: '12px 16px',
						borderRadius: 2,
						border: '1px solid #ccc',
						boxShadow: '0px 4px 12px rgba(0,0,0,0.2)',
						maxWidth: 260
					}
				},
				arrow: {
					sx: {
						color: '#FC4B58'
					}
				}
			}}
		>
			<IconButton
				size={size}
				className={classes.iconStyles}
				sx={{
					backgroundColor: bgColor,
					color: iconColor,
					'&:hover': { backgroundColor: hoverBgColor },
					...customIconStyles
				}}
			>
				<InfoOutlinedIcon
					fontSize={['small', 'medium', 'large'].includes(iconSize) ? iconSize : 'medium'}
					sx={!['small', 'medium', 'large'].includes(iconSize) ? { fontSize: iconSize } : {}}
				/>
			</IconButton>
		</Tooltip>
	);
}

export default InfoButton;
